import React from "react";
import { observer } from "mobx-react";
import { GrossReceiptsStatusViewStore } from "../../store";
import { GrossReceiptsStatusViewForm } from "./GrossReceiptsStatusViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type GrossReceiptsStatusViewProps = {
  grossReceiptsStatusViewStore: GrossReceiptsStatusViewStore;
};

export const GrossReceiptsStatusView: React.FC<GrossReceiptsStatusViewProps> =
  observer(({ grossReceiptsStatusViewStore }) => {
    return (
      <div>
        <GrossReceiptsStatusViewForm
          name_es={grossReceiptsStatusViewStore.name_esValue}
          name_en={grossReceiptsStatusViewStore.name_enValue}
          name_pt={grossReceiptsStatusViewStore.name_ptValue}
          description_es={grossReceiptsStatusViewStore.description_esValue}
          description_en={grossReceiptsStatusViewStore.description_enValue}
          description_pt={grossReceiptsStatusViewStore.description_ptValue}
          onPrint={(handlePrint: () => void) =>
            grossReceiptsStatusViewStore.printGrossReceiptsStatus(handlePrint)
          }
          onCancel={() =>
            grossReceiptsStatusViewStore.cancelGrossReceiptsStatus()
          }
          onEdit={
            grossReceiptsStatusViewStore.isEditEnabled
              ? () => grossReceiptsStatusViewStore.editGrossReceiptsStatus()
              : undefined
          }
        />
        <ErrorDialog
          open={grossReceiptsStatusViewStore.errorDialogOpened}
          title={grossReceiptsStatusViewStore.errorTitle}
          description={grossReceiptsStatusViewStore.errorDescription}
          onClose={() => grossReceiptsStatusViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
